import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Pitfall 2 (RESEARCH.md): set data-domain synchronously BEFORE first paint to
// prevent a flash of un-themed content on the .ai build. REACT_APP_DOMAIN is
// baked at build time by the per-domain Dokploy services (net/ai/io/dev/
// manzoorulhassan), so this read is safe at module load.
const domainId = process.env.REACT_APP_DOMAIN || 'dev';
document.documentElement.setAttribute('data-domain', domainId);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
